
import { Pipe, PipeTransform } from '@angular/core';
import { ColumnsModel } from '@models/ColumnsModel';

@Pipe({
    name: 'displayColName',
    standalone: true
})
export class DisplayColNamePipe implements PipeTransform {
    transform(col: string): string {
        const cols = JSON.parse(localStorage.getItem('display_cols')!);
        let displayColName = col;
        if (cols) {
            const colObj = cols.find((c: ColumnsModel) => c.db_column_name == col);
            if (colObj) {
                displayColName = colObj.ui_column_name;
            } else {
                displayColName = this.formatColumnName(displayColName);
            }
        } else {
            displayColName = this.formatColumnName(displayColName);
        }
        return displayColName;
    }
    formatColumnName(value: string): string {
        if (!value) return '';
        return value
            .split('_')                         // Split at underscores
            .map(word =>
                word.charAt(0).toUpperCase() +
                word.slice(1).toLowerCase()      // Capitalize first letter of each word
            )
            .join(' ');
    }
}